import { InjectionToken } from '@angular/core';
import { SealedTradingCommandPort } from '../ports/sealed-trading-command.port';

export const SEALED_TRADING_COMMAND_TOKEN = new InjectionToken<SealedTradingCommandPort>(
    'SealedTradingCommandPort'
);


